import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const State = Record({
    updating: false,
});

export default handleActions(
    {
        [Actions.update.type]: state =>
            state.merge({
                updating: true,
            }),
        [Actions.updateSuccess.type]: state =>
            state.merge({
                updating: false,
            }),
        [Actions.updateFailed.type]: state =>
            state.merge({
                updating: false,
            }),
    },
    new State(),
);
